exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr.hidden-item[data-v-d0d90544] {\n  background: #cccccc;\n}\ntr.sales-quantity-error[data-v-d0d90544] {\n  background: #FCCBCB;\n}\ntr > td[data-v-d0d90544] {\n  vertical-align: middle;\n  border-color: #777777;\n  font-size: 0.8rem;\n}\ntr > td[data-v-d0d90544]:nth-of-type(3), tr > td[data-v-d0d90544]:nth-of-type(4) {\n    padding: 0.75rem 0.3rem;\n}\ntr > td.col1[data-v-d0d90544] {\n    font-size: 1rem;\n}\ntr > td.col1.hasRequest[data-v-d0d90544] {\n      color: #ff0000;\n      font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0d90544","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/parts/ItemTableRow.vue
// module id = 5IFl
// module chunks = 1